import { Container, Navbar, Modal, Button } from "react-bootstrap";
import { AiOutlineLogout } from "react-icons/ai";
import Logo from "../../assets/Images/logo.png";
import WebService from "../../Services/WebService";
import { useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileDropdown from "./ProfileDropdown";

const SalesHeader = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const getNotificationToken = () => localStorage.getItem("fcm_device_token");

  const unregisterDevice = () => {
    WebService.addLoader("deleteBtnModal");
    return WebService.postAPI({
      action: `unregister-device`,
      body: {
        token: getNotificationToken(),
        push_type: "WEB_PUSH",
      },
      isShowError: false,
    })
      .then((res: any) => {
        WebService.removeLoader("deleteBtnModal");
        WebService.logout();
      })
      .catch((error: any) => {
        WebService.removeLoader("deleteBtnModal");
        toast.error(error?.response?.data?.message);
        return error;
      });
  };

  return (
    <>
      <header className="site-header" style={{ width: "100%", left: 0 }}>
        <Container fluid className="header-nav">
          <Navbar className="position-relative w-100 d-flex justify-content-between align-items-center">
            <Navbar.Brand className="font-bold d-flex align-items-center m-0" style={{ cursor: "pointer" }}>
              <img
                src={Logo}
                width={130}
                alt="Prime Shark"
                style={{
                  filter: "drop-shadow(0px 4px 8px rgba(0,0,0,0.3))",
                  transition: "transform 0.3s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.03)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "none"}
              />
            </Navbar.Brand>

            <div className="position-absolute top-50 start-50 translate-middle d-none d-md-block bg-light px-4 py-2 rounded-pill shadow-sm" style={{ border: "1px solid #ebf5ea" }}>
              <h5 className="mb-0 fw-bold" style={{ color: "#66C15E", letterSpacing: "1px", textTransform: "uppercase", fontSize: "15px" }}>
                Prime Shark Sales Portal
              </h5>
            </div>

            <div className="d-flex align-items-center ms-auto gap-3">
              <ProfileDropdown setShowLogout={setShow} />
            </div>
          </Navbar>
        </Container>

        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={() => setShow(false)}
        >
          <Modal.Header closeButton className="border-bottom-0 pb-0">
            <h4 className="font-24 ">Logout?</h4>
          </Modal.Header>

          <Modal.Body className="pt-0">
            <div className="mb-4 text-center">
              <p className="mb-0">Are you sure you want to logout?</p>
            </div>
            <div className="text-center">
              <Button
                variant="secondary me-3 px-5"
                onClick={() => {
                  setShow(false);
                }}
              >
                No
              </Button>
              <Button
                variant="danger px-3 p-2"
                style={{ width: "117px" }}
                id="deleteBtnModal"
                onClick={() => {
                  if (getNotificationToken()) {
                    unregisterDevice();
                  } else WebService.logout();
                }}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};
export default SalesHeader;
